import com.tixforgigs.common.core.enums.ClientType
import com.tixforgigs.common.core.util.IdHelper
import com.tixforgigs.common.http.HttpClient
import com.tixforgigs.configurator.BuildKonfig
import com.tixforgigs.storefront.TemplateConfiguratorApp
import io.kvision.CoreModule
import io.kvision.Hot
import io.kvision.MaterialModule
import io.kvision.startApplication

fun main() {
  HttpClient.init(
    type = ClientType.TEMPLATE_CONFIGURATOR,
    flavor = IdHelper.flavor,
    baseUrl = BuildKonfig.HOST_URL,
    authClientId = IdHelper.authClientId,
    apiClientId = IdHelper.apiClientId,
    sentryUrl = BuildKonfig.SENTRY_URL
  )

  startApplication(
    ::TemplateConfiguratorApp,
    js("import.meta.webpackHot").unsafeCast<Hot?>(),
    CoreModule,
    MaterialModule
  )
}